import images from './img-assets'
import strings from './strings'

const R = {
  images,
  strings: strings(),
}

export default R
